"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _LunaLink = _interopRequireDefault(require("../LunaLink/LunaLink"));
require("./OnPageNav.scss");
var _react = _interopRequireWildcard(require("react"));
var _useScreenSize = require("../../utils/hooks/useScreenSize");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const OnPageNav = _ref => {
  let {
    navItems,
    navCta,
    navTitle
  } = _ref;
  const [pathname, setPathname] = (0, _react.useState)(false);
  const [navOverflowing, setNavOverflowing] = (0, _react.useState)(false);
  const [navCheckComplete, setNavCheckComplete] = (0, _react.useState)(false);
  const [overflowMenuOpen, setOverflowMenuOpen] = (0, _react.useState)(false);
  const [mobileMenuOpen, setMobileMenuOpen] = (0, _react.useState)(false);
  const [overflowMenuPosX, setOverflowMenuPosX] = (0, _react.useState)(0);
  const [overflowMenuPosY, setOverflowMenuPosY] = (0, _react.useState)(0);
  const [overflowItems, setOverflowItems] = (0, _react.useState)(null);
  const overflowMenuRef = (0, _react.useRef)(null);
  const overflowIconRef = (0, _react.useRef)(null);
  const onPageNavRef = (0, _react.useRef)(null);
  let mainNavItems = navItems;
  const {
    width
  } = _useScreenSize.useScreenSize;
  const handleCloseEvent = () => {
    setOverflowMenuOpen(false);
    setMobileMenuOpen(false);
  };
  (0, _react.useEffect)(() => {
    if (typeof window !== "undefined") {
      setPathname(window?.location?.pathname);
      window?.addEventListener("click", handleCloseEvent);
      window?.addEventListener("scroll", handleCloseEvent);
      window?.addEventListener("resize", handleCloseEvent);
    }
    return () => {
      if (typeof window !== "undefined") {
        window?.removeEventListener("click", handleCloseEvent);
        window?.removeEventListener("scroll", handleCloseEvent);
        window?.removeEventListener("resize", handleCloseEvent);
      }
    };
  }, []);
  (0, _react.useEffect)(() => {
    // this controls CSS positions for the overflow menu 
    if (navCheckComplete) {
      setOverflowMenuPosY(parseInt(overflowIconRef?.current?.getBoundingClientRect()?.bottom - 16));
      setOverflowMenuPosX(parseInt(window?.innerWidth - overflowIconRef?.current?.getBoundingClientRect()?.right - 14));
    }
  });
  const navItemVisibleCheck = items => {
    let callback = (entries, observer) => {
      entries?.forEach(entry => {
        if (entry?.isIntersecting === false) {
          // if element is invisible in the dom, push it to the overflow menu
          entry?.target?.classList?.add("ter-on-page-nav__menu-item--overflow");
          setNavOverflowing(true);
        } else {
          entry?.target?.classList?.remove("ter-on-page-nav__menu-item--overflow");
        }
      });
    };
    let observer = new IntersectionObserver(callback, {
      root: document?.querySelector('.ter-on-page-nav__menu'),
      rootMargin: "0px",
      threshold: 1.0
    });
    items?.forEach(item => {
      observer?.observe(item);
    });
    setNavCheckComplete(true);
  };
  (0, _react.useEffect)(() => {
    if (onPageNavRef?.current && onPageNavRef?.current?.innerHTML) {
      navItemVisibleCheck(document?.querySelectorAll('.ter-on-page-nav__menu > .ter-on-page-nav__menu-item'));
    }
  }, [onPageNavRef?.current?.offsetWidth, width]);
  const overflowClickHandler = e => {
    const items = document?.querySelectorAll('.ter-on-page-nav__menu > .ter-on-page-nav__menu-item--overflow');
    processOverflowItems(items);
    setOverflowMenuOpen(!overflowMenuOpen);
  };
  const processOverflowItems = items => {
    let overflowStateItems = [];
    items.forEach(item => {
      overflowStateItems.push(mainNavItems[item?.dataset.itemIndex]);
    });
    setOverflowItems(overflowStateItems);
  };
  const isActivePage = (navItemUrl, currentPage) => {
    if (navItemUrl && currentPage) {
      const itemUrl = navItemUrl?.split("/")[navItemUrl?.split("/")?.length - 1];
      const currentPageUrl = currentPage?.split("/")[currentPage?.split("/")?.length - 1];
      const isActivePage = currentPageUrl && currentPageUrl?.includes(itemUrl);
      return isActivePage;
    }
    return false;
  };
  const renderOnPageNavMenuMobile = () => {
    const calcMobileNavHeight = () => {
      return 56 * navItems?.length;
    };
    return /*#__PURE__*/_react.default.createElement("ul", {
      style: {
        minHeight: calcMobileNavHeight()
      }
    }, navItems?.map((item, i) => {
      const activeItem = isActivePage(item?.url, pathname);
      return /*#__PURE__*/_react.default.createElement("li", {
        key: `on-page-nav-${i}`,
        className: `ter-on-page-nav__mobile-menu-item ${activeItem ? "ter-on-page-nav__menu-item--active" : ""}`
      }, /*#__PURE__*/_react.default.createElement(_LunaLink.default, {
        to: item?.url,
        className: `ter-on-page-nav__mobile-menu-link`,
        target: item?.external ? "_blank" : "_self",
        Link: item?.Link
      }, item?.text));
    }), navCta && /*#__PURE__*/_react.default.createElement("li", {
      className: `ter-on-page-nav__mobile-menu-item ter-on-page-nav__cta`
    }, /*#__PURE__*/_react.default.createElement(_LunaLink.default, {
      className: 'ter-button ter-button--primary--2',
      to: navCta?.url,
      target: navCta?.external ? "_blank" : "_self",
      Link: navCta?.Link
    }, navCta?.text)));
  };
  const renderMainNavItems = navItems => {
    return navItems?.map((item, i) => {
      const activeItem = isActivePage(item?.url, pathname);
      return /*#__PURE__*/_react.default.createElement("li", {
        key: `on-page-nav-${i}`,
        "data-item-index": i,
        className: `ter-on-page-nav__menu-item ${activeItem ? "ter-on-page-nav__menu-item--active" : ""} ter-on-page-nav__menu-item-link`
      }, /*#__PURE__*/_react.default.createElement(_LunaLink.default, {
        to: item?.url,
        target: item?.external ? "_blank" : "_self",
        Link: item?.Link
      }, item?.text));
    });
  };
  const OnPageNavOverflow = _ref2 => {
    let {
      items
    } = _ref2;
    if (items === null || typeof items === "undefined" || items === '') {
      return;
    }
    ;
    if (items?.map) {
      return items?.map((item, i) => {
        const activeItem = isActivePage(item?.url, pathname);
        return /*#__PURE__*/_react.default.createElement("li", {
          key: `on-page-nav-${i}`,
          className: `ter-on-page-nav__menu-item ter-on-page-nav__menu-item-link ter-on-page-nav__menu-item--overflow ${activeItem ? "ter-on-page-nav__menu-item--active" : ""}`
        }, /*#__PURE__*/_react.default.createElement(_LunaLink.default, {
          to: item?.url,
          target: item?.external ? "_blank" : "_self",
          Link: item?.Link
        }, item?.text));
      });
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: `ter-on-page-nav ${mobileMenuOpen ? "ter-on-page-nav__mobile-menu--open" : ""}`
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "default-layout"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "default-layout__grid ter-on-page-nav__wrapper"
  }, /*#__PURE__*/_react.default.createElement("nav", {
    className: `ter-on-page-nav__inner-wrapper`
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: `ter-on-page-nav__title-holder`
  }, /*#__PURE__*/_react.default.createElement("h4", {
    className: "ter-on-page-nav__title"
  }, navTitle)), /*#__PURE__*/_react.default.createElement("div", {
    className: `ter-on-page-nav__nav-holder`
  }, /*#__PURE__*/_react.default.createElement("ul", {
    ref: onPageNavRef,
    className: `ter-on-page-nav__menu ${navOverflowing ? "ter-on-page-nav__menu--overflowing" : ""}`
  }, renderMainNavItems(mainNavItems))), /*#__PURE__*/_react.default.createElement("div", {
    className: `ter-on-page-nav__extras-holder`
  }, navOverflowing && /*#__PURE__*/_react.default.createElement("div", {
    className: `ter-on-page-nav__menu-item ter-on-page-nav__collapse-icon ${overflowMenuOpen ? "ter-on-page-nav__collapse-icon--open" : ""}`,
    onClick: e => overflowClickHandler(e),
    ref: overflowIconRef
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: `ter-on-page-nav__collapse-icon-wrapper ter-on-page-nav__collapse-icon-dots`
  }, /*#__PURE__*/_react.default.createElement("span", null))), navCta && /*#__PURE__*/_react.default.createElement("div", {
    className: `ter-on-page-nav__menu-item ter-on-page-nav__cta`
  }, /*#__PURE__*/_react.default.createElement(_LunaLink.default, {
    className: 'ter-button ter-button--primary--2',
    to: navCta?.url,
    target: navCta?.external ? "_blank" : "_self",
    Link: navCta?.Link
  }, navCta?.text))), /*#__PURE__*/_react.default.createElement("div", {
    className: `ter-on-page-nav__collapse-holder`,
    onClick: () => {
      setMobileMenuOpen(!mobileMenuOpen);
    }
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: `ter-on-page-nav__collapse-mobile ${mobileMenuOpen ? 'ter-on-page-nav__collapse-mobile--open' : ''}`
  }, /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "25",
    fill: "currentColor",
    className: `ter-on-page-nav__chevron`,
    role: "img",
    "aria-label": "dropdown chevron icon"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: "currentColor",
    d: "M1.88.453 8 6.56 14.12.453 16 2.333l-8 8-8-8L1.88.453Z"
  }))))))), /*#__PURE__*/_react.default.createElement("div", {
    className: `ter-on-page-nav__mobile-menu ${mobileMenuOpen ? "ter-on-page-nav__mobile-menu--open" : ""}`
  }, renderOnPageNavMenuMobile()), /*#__PURE__*/_react.default.createElement("div", {
    className: `ter-on-page-nav__overflow-menu ${overflowMenuOpen ? "ter-on-page-nav__overflow-menu--open" : ""}`,
    style: {
      right: overflowMenuPosX || "",
      top: overflowMenuPosY || ""
    }
  }, /*#__PURE__*/_react.default.createElement("ul", {
    ref: overflowMenuRef,
    className: `ter-on-page-nav__overflow-menu-list`
  }, /*#__PURE__*/_react.default.createElement(OnPageNavOverflow, {
    items: overflowItems
  }))));
};
var _default = OnPageNav;
exports.default = _default;